import { render, staticRenderFns } from "./flowInformation.vue?vue&type=template&id=95bb7374&scoped=true"
import script from "./flowInformation.vue?vue&type=script&lang=js"
export * from "./flowInformation.vue?vue&type=script&lang=js"
import style0 from "./flowInformation.vue?vue&type=style&index=0&id=95bb7374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bb7374",
  null
  
)

export default component.exports